import { render, staticRenderFns } from "./config.vue?vue&type=template&id=005d9678"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"
import style0 from "./config.vue?vue&type=style&index=0&id=005d9678&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005d9678')) {
      api.createRecord('005d9678', component.options)
    } else {
      api.reload('005d9678', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=005d9678", function () {
      api.rerender('005d9678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/config.vue"
export default component.exports